import React, { useState, useRef, useEffect } from "react";
import {
  FaCheck,
  FaCalendar,
  FaUsers,
  FaCreditCard,
  FaUtensils,
  FaChevronDown,
} from "react-icons/fa";
import AvailabilityCalendar from "./AvailabilityCalendar";
import PaymentCheckout from "./PaymentCheckout";
import { useBooking } from "../../hooks/useBooking";
import { useNavigate } from "react-router-dom";

const COUNTRY_CODES = [
  { code: "AL", name: "Albania", dial: "+355" },
  { code: "AF", name: "Afghanistan", dial: "+93" },
  { code: "DZ", name: "Algeria", dial: "+213" },
  { code: "AD", name: "Andorra", dial: "+376" },
  { code: "AO", name: "Angola", dial: "+244" },
  { code: "AR", name: "Argentina", dial: "+54" },
  { code: "AM", name: "Armenia", dial: "+374" },
  { code: "AU", name: "Australia", dial: "+61" },
  { code: "AT", name: "Austria", dial: "+43" },
  { code: "AZ", name: "Azerbaijan", dial: "+994" },
  { code: "BS", name: "Bahamas", dial: "+1242" },
  { code: "BH", name: "Bahrain", dial: "+973" },
  { code: "BD", name: "Bangladesh", dial: "+880" },
  { code: "BY", name: "Belarus", dial: "+375" },
  { code: "BE", name: "Belgium", dial: "+32" },
  { code: "BZ", name: "Belize", dial: "+501" },
  { code: "BJ", name: "Benin", dial: "+229" },
  { code: "BT", name: "Bhutan", dial: "+975" },
  { code: "BO", name: "Bolivia", dial: "+591" },
  { code: "BA", name: "Bosnia & Herzegovina", dial: "+387" },
  { code: "BW", name: "Botswana", dial: "+267" },
  { code: "BR", name: "Brazil", dial: "+55" },
  { code: "BN", name: "Brunei", dial: "+673" },
  { code: "BG", name: "Bulgaria", dial: "+359" },
  { code: "BF", name: "Burkina Faso", dial: "+226" },
  { code: "BI", name: "Burundi", dial: "+257" },
  { code: "KH", name: "Cambodia", dial: "+855" },
  { code: "CM", name: "Cameroon", dial: "+237" },
  { code: "CA", name: "Canada", dial: "+1" },
  { code: "CV", name: "Cape Verde", dial: "+238" },
  { code: "CF", name: "Central African Rep.", dial: "+236" },
  { code: "TD", name: "Chad", dial: "+235" },
  { code: "CL", name: "Chile", dial: "+56" },
  { code: "CN", name: "China", dial: "+86" },
  { code: "CO", name: "Colombia", dial: "+57" },
  { code: "KM", name: "Comoros", dial: "+269" },
  { code: "CG", name: "Congo", dial: "+242" },
  { code: "CR", name: "Costa Rica", dial: "+506" },
  { code: "HR", name: "Croatia", dial: "+385" },
  { code: "CU", name: "Cuba", dial: "+53" },
  { code: "CY", name: "Cyprus", dial: "+357" },
  { code: "CZ", name: "Czech Republic", dial: "+420" },
  { code: "DK", name: "Denmark", dial: "+45" },
  { code: "DJ", name: "Djibouti", dial: "+253" },
  { code: "DO", name: "Dominican Republic", dial: "+1809" },
  { code: "EC", name: "Ecuador", dial: "+593" },
  { code: "EG", name: "Egypt", dial: "+20" },
  { code: "SV", name: "El Salvador", dial: "+503" },
  { code: "GQ", name: "Equatorial Guinea", dial: "+240" },
  { code: "ER", name: "Eritrea", dial: "+291" },
  { code: "EE", name: "Estonia", dial: "+372" },
  { code: "ET", name: "Ethiopia", dial: "+251" },
  { code: "FJ", name: "Fiji", dial: "+679" },
  { code: "FI", name: "Finland", dial: "+358" },
  { code: "FR", name: "France", dial: "+33" },
  { code: "GA", name: "Gabon", dial: "+241" },
  { code: "GM", name: "Gambia", dial: "+220" },
  { code: "GE", name: "Georgia", dial: "+995" },
  { code: "DE", name: "Germany", dial: "+49" },
  { code: "GH", name: "Ghana", dial: "+233" },
  { code: "GR", name: "Greece", dial: "+30" },
  { code: "GT", name: "Guatemala", dial: "+502" },
  { code: "GN", name: "Guinea", dial: "+224" },
  { code: "GW", name: "Guinea-Bissau", dial: "+245" },
  { code: "GY", name: "Guyana", dial: "+592" },
  { code: "HT", name: "Haiti", dial: "+509" },
  { code: "HN", name: "Honduras", dial: "+504" },
  { code: "HK", name: "Hong Kong", dial: "+852" },
  { code: "HU", name: "Hungary", dial: "+36" },
  { code: "IS", name: "Iceland", dial: "+354" },
  { code: "IN", name: "India", dial: "+91" },
  { code: "ID", name: "Indonesia", dial: "+62" },
  { code: "IR", name: "Iran", dial: "+98" },
  { code: "IQ", name: "Iraq", dial: "+964" },
  { code: "IE", name: "Ireland", dial: "+353" },
  { code: "IL", name: "Israel", dial: "+972" },
  { code: "IT", name: "Italy", dial: "+39" },
  { code: "JM", name: "Jamaica", dial: "+1876" },
  { code: "JP", name: "Japan", dial: "+81" },
  { code: "JO", name: "Jordan", dial: "+962" },
  { code: "KZ", name: "Kazakhstan", dial: "+7" },
  { code: "KE", name: "Kenya", dial: "+254" },
  { code: "KW", name: "Kuwait", dial: "+965" },
  { code: "KG", name: "Kyrgyzstan", dial: "+996" },
  { code: "LA", name: "Laos", dial: "+856" },
  { code: "LV", name: "Latvia", dial: "+371" },
  { code: "LB", name: "Lebanon", dial: "+961" },
  { code: "LS", name: "Lesotho", dial: "+266" },
  { code: "LR", name: "Liberia", dial: "+231" },
  { code: "LY", name: "Libya", dial: "+218" },
  { code: "LI", name: "Liechtenstein", dial: "+423" },
  { code: "LT", name: "Lithuania", dial: "+370" },
  { code: "LU", name: "Luxembourg", dial: "+352" },
  { code: "MO", name: "Macau", dial: "+853" },
  { code: "MG", name: "Madagascar", dial: "+261" },
  { code: "MW", name: "Malawi", dial: "+265" },
  { code: "MY", name: "Malaysia", dial: "+60" },
  { code: "MV", name: "Maldives", dial: "+960" },
  { code: "ML", name: "Mali", dial: "+223" },
  { code: "MT", name: "Malta", dial: "+356" },
  { code: "MR", name: "Mauritania", dial: "+222" },
  { code: "MU", name: "Mauritius", dial: "+230" },
  { code: "MX", name: "Mexico", dial: "+52" },
  { code: "MD", name: "Moldova", dial: "+373" },
  { code: "MC", name: "Monaco", dial: "+377" },
  { code: "MN", name: "Mongolia", dial: "+976" },
  { code: "ME", name: "Montenegro", dial: "+382" },
  { code: "MA", name: "Morocco", dial: "+212" },
  { code: "MZ", name: "Mozambique", dial: "+258" },
  { code: "MM", name: "Myanmar", dial: "+95" },
  { code: "NA", name: "Namibia", dial: "+264" },
  { code: "NP", name: "Nepal", dial: "+977" },
  { code: "NL", name: "Netherlands", dial: "+31" },
  { code: "NZ", name: "New Zealand", dial: "+64" },
  { code: "NI", name: "Nicaragua", dial: "+505" },
  { code: "NE", name: "Niger", dial: "+227" },
  { code: "NG", name: "Nigeria", dial: "+234" },
  { code: "MK", name: "North Macedonia", dial: "+389" },
  { code: "NO", name: "Norway", dial: "+47" },
  { code: "OM", name: "Oman", dial: "+968" },
  { code: "PK", name: "Pakistan", dial: "+92" },
  { code: "PS", name: "Palestine", dial: "+970" },
  { code: "PA", name: "Panama", dial: "+507" },
  { code: "PG", name: "Papua New Guinea", dial: "+675" },
  { code: "PY", name: "Paraguay", dial: "+595" },
  { code: "PE", name: "Peru", dial: "+51" },
  { code: "PH", name: "Philippines", dial: "+63" },
  { code: "PL", name: "Poland", dial: "+48" },
  { code: "PT", name: "Portugal", dial: "+351" },
  { code: "QA", name: "Qatar", dial: "+974" },
  { code: "RO", name: "Romania", dial: "+40" },
  { code: "RU", name: "Russia", dial: "+7" },
  { code: "RW", name: "Rwanda", dial: "+250" },
  { code: "SA", name: "Saudi Arabia", dial: "+966" },
  { code: "SN", name: "Senegal", dial: "+221" },
  { code: "RS", name: "Serbia", dial: "+381" },
  { code: "SL", name: "Sierra Leone", dial: "+232" },
  { code: "SG", name: "Singapore", dial: "+65" },
  { code: "SK", name: "Slovakia", dial: "+421" },
  { code: "SI", name: "Slovenia", dial: "+386" },
  { code: "SO", name: "Somalia", dial: "+252" },
  { code: "ZA", name: "South Africa", dial: "+27" },
  { code: "SS", name: "South Sudan", dial: "+211" },
  { code: "ES", name: "Spain", dial: "+34" },
  { code: "LK", name: "Sri Lanka", dial: "+94" },
  { code: "SD", name: "Sudan", dial: "+249" },
  { code: "SR", name: "Suriname", dial: "+597" },
  { code: "SE", name: "Sweden", dial: "+46" },
  { code: "CH", name: "Switzerland", dial: "+41" },
  { code: "SY", name: "Syria", dial: "+963" },
  { code: "TW", name: "Taiwan", dial: "+886" },
  { code: "TJ", name: "Tajikistan", dial: "+992" },
  { code: "TZ", name: "Tanzania", dial: "+255" },
  { code: "TH", name: "Thailand", dial: "+66" },
  { code: "TG", name: "Togo", dial: "+228" },
  { code: "TT", name: "Trinidad & Tobago", dial: "+1868" },
  { code: "TN", name: "Tunisia", dial: "+216" },
  { code: "TR", name: "Turkey", dial: "+90" },
  { code: "TM", name: "Turkmenistan", dial: "+993" },
  { code: "UG", name: "Uganda", dial: "+256" },
  { code: "UA", name: "Ukraine", dial: "+380" },
  { code: "AE", name: "United Arab Emirates", dial: "+971" },
  { code: "GB", name: "United Kingdom", dial: "+44" },
  { code: "US", name: "United States", dial: "+1" },
  { code: "UY", name: "Uruguay", dial: "+598" },
  { code: "UZ", name: "Uzbekistan", dial: "+998" },
  { code: "VE", name: "Venezuela", dial: "+58" },
  { code: "VN", name: "Vietnam", dial: "+84" },
  { code: "YE", name: "Yemen", dial: "+967" },
  { code: "ZM", name: "Zambia", dial: "+260" },
  { code: "ZW", name: "Zimbabwe", dial: "+263" },
];

const BookingFlow = ({ serviceData, serviceType }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [phonePrefix, setPhonePrefix] = useState("+355");
  const [localPhone, setLocalPhone] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const continueButtonRef = useRef(null);
  const [continueBtnVisible, setContinueBtnVisible] = useState(true);

  useEffect(() => {
    const el = continueButtonRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => setContinueBtnVisible(entry.isIntersecting),
      { threshold: 0.3 },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [currentStep]);
  const [bookingData, setBookingData] = useState({
    serviceId: serviceData.id,
    serviceType: serviceType,
    date: null,
    timeSlot: null,
    numberOfGuests: serviceData.minCapacity || 1,
    jetSkiPackage: "rental-15",
    totalPrice: 0,
    extras: {
      drinks: {}, // { itemId: quantity }
      food: {}, // { itemId: quantity }
      jetSki: false, // 15 min on-board jet ski add-on
    },
    customerInfo: {
      name: "",
      email: "",
      phone: "",
      address: "",
    },
  });

  const [slotRemainingCapacity, setSlotRemainingCapacity] = useState(null);
  const { createBooking } = useBooking();
  const navigate = useNavigate();

  const steps = [
    { number: 1, title: "Select Date & Time", icon: FaCalendar },
    { number: 2, title: "Guest Details", icon: FaUsers },
    { number: 3, title: "Extras", icon: FaUtensils },
    { number: 4, title: "Payment", icon: FaCreditCard },
  ];

  // Available extras options
  const extrasOptions = {
    drinks: [
      { id: "water", name: "Bottled Water", price: 2 },
      { id: "softdrink", name: "Soft Drink", price: 3 },
      { id: "beer", name: "Local Beer", price: 5 },
      { id: "champagne", name: "Champagne", price: 30 },
    ],
    food: [
      { id: "seafood-salad", name: "Cold seafood salad", price: 20 },
      { id: "mix-crudo", name: "Mix crudo", price: 45 },
      { id: "linguine-seafood", name: "Linguine seafood", price: 15 },
      { id: "risotto-seafood", name: "Risotto seafood", price: 15 },
      { id: "seafood-fried", name: "Seafood mix fried", price: 30 },
      { id: "seafood-grilled", name: "Seafood mix grilled", price: 30 },
      // { id: "chocolate-souffle", name: "Chocolate soufflé", price: 5 },
    ],
  };

  // Calculate total price
  const calculateTotalPrice = () => {
    const sid = bookingData.serviceId;
    let basePrice;
    if (sid === "luxury-yacht") {
      const extra = Math.max(0, bookingData.numberOfGuests - 5) * 50;
      basePrice = 600 + extra;
    } else if (sid === "jet-ski") {
      const pkgPrices = {
        "rental-15": 50,
        "rental-30": 90,
      };
      basePrice = pkgPrices[bookingData.jetSkiPackage] ?? 50;
    } else if (sid === "bayliner") {
      // Flat group price regardless of number of guests
      basePrice = serviceData.price;
    } else {
      basePrice = serviceData.price * bookingData.numberOfGuests;
    }

    // Calculate extras total
    let extrasTotal = 0;

    // Drinks
    if (bookingData.extras.drinks) {
      Object.entries(bookingData.extras.drinks).forEach(
        ([drinkId, quantity]) => {
          const drink = extrasOptions.drinks.find((d) => d.id === drinkId);
          if (drink) extrasTotal += drink.price * quantity;
        },
      );
    }

    // Food
    if (bookingData.extras.food) {
      Object.entries(bookingData.extras.food).forEach(([foodId, quantity]) => {
        const food = extrasOptions.food.find((f) => f.id === foodId);
        if (food) extrasTotal += food.price * quantity;
      });
    }

    return basePrice + extrasTotal;
  };

  const getBasePrice = () => {
    const sid = bookingData.serviceId;
    if (sid === "luxury-yacht") {
      return 600 + Math.max(0, bookingData.numberOfGuests - 5) * 50;
    }
    if (sid === "jet-ski") {
      const pkgPrices = {
        "rental-15": 50,
        "rental-30": 90,
      };
      return pkgPrices[bookingData.jetSkiPackage] ?? 50;
    }
    if (sid === "bayliner") {
      return serviceData.price; // flat group price
    }
    return serviceData.price * bookingData.numberOfGuests;
  };

  const getMinGuests = () => serviceData.minCapacity || 1;

  const getMaxGuests = () => {
    const absoluteMax =
      bookingData.serviceId === "luxury-yacht"
        ? 11
        : bookingData.serviceId === "jet-ski"
          ? 2
          : bookingData.serviceId === "bayliner"
            ? 4
            : 11;
    if (slotRemainingCapacity !== null) {
      return Math.min(absoluteMax, slotRemainingCapacity);
    }
    return absoluteMax;
  };

  const handleDateSelect = (date) => {
    setSlotRemainingCapacity(null);
    setBookingData((prev) => ({
      ...prev,
      date,
      timeSlot: null,
      numberOfGuests: getMinGuests(),
    }));
  };

  const handleTimeSlotSelect = (timeSlot, remainingCapacity) => {
    setSlotRemainingCapacity(remainingCapacity ?? null);
    // Clamp current guest count to the new remaining capacity
    setBookingData((prev) => ({
      ...prev,
      timeSlot,
      numberOfGuests:
        remainingCapacity != null
          ? Math.min(prev.numberOfGuests, remainingCapacity)
          : prev.numberOfGuests,
    }));
  };

  const handleGuestsChange = (guests) => {
    const clamped = Math.min(Math.max(getMinGuests(), guests), getMaxGuests());
    setBookingData((prev) => ({
      ...prev,
      numberOfGuests: clamped,
      totalPrice: calculateTotalPrice(),
    }));
  };

  const handleCustomerInfoChange = (field, value) => {
    setBookingData((prev) => ({
      ...prev,
      customerInfo: { ...prev.customerInfo, [field]: value },
    }));
    // Clear validation error for this field
    setValidationErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    // Accept international format with country code (+xxx)
    const phoneRegex = /^\+?[1-9]\d{1,14}$/; // E.164 format
    const cleanPhone = phone.replace(/[\s\-()]/g, ""); // Remove spaces, dashes, parentheses
    return phoneRegex.test(cleanPhone);
  };

  const validateGuestDetails = () => {
    const errors = {};

    if (!bookingData.customerInfo.name.trim()) {
      errors.name = "Full name is required";
    }

    if (!bookingData.customerInfo.email.trim()) {
      errors.email = "Email address is required";
    } else if (!validateEmail(bookingData.customerInfo.email)) {
      errors.email = "Please enter a valid email address";
    }

    if (!bookingData.customerInfo.phone.trim()) {
      errors.phone = "Phone number is required";
    } else if (!validatePhone(bookingData.customerInfo.phone)) {
      errors.phone =
        "Please enter a valid phone number with country code (e.g., +355 69 123 4567)";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleExtrasChange = (type, itemId, change) => {
    setBookingData((prev) => {
      const currentQuantity = prev.extras[type][itemId] || 0;
      const newQuantity = Math.max(0, currentQuantity + change);

      const newExtras = { ...prev.extras[type] };

      if (newQuantity === 0) {
        delete newExtras[itemId];
      } else {
        newExtras[itemId] = newQuantity;
      }

      return {
        ...prev,
        extras: {
          ...prev.extras,
          [type]: newExtras,
        },
      };
    });
  };

  const handleNextStep = () => {
    if (currentStep === 1 && (!bookingData.date || !bookingData.timeSlot)) {
      alert("Please select a date and time slot");
      return;
    }
    if (currentStep === 2 && !bookingData.customerInfo.name) {
      alert("Please fill in your details");
      return;
    }
    setCurrentStep((prev) => prev + 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlePreviousStep = () => {
    setCurrentStep((prev) => prev - 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlePaymentSuccess = (paymentData) => {
    navigate(
      `/booking-success?ref=${paymentData.bookingReference || paymentData.bookingId}`,
    );
  };

  return (
    <>
      <div className="booking-flow max-w-7xl mx-auto px-3 sm:px-6 py-4 sm:py-8 lg:p-8">
        {/* Progress Steps */}
        <div className="mb-4 sm:mb-8 lg:mb-10">
          <div className="flex items-center justify-between">
            {steps.map((step, index) => (
              <React.Fragment key={step.number}>
                <div className="flex flex-col items-center relative flex-shrink-0 min-w-0">
                  <div
                    className={`w-8 h-8 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-full flex items-center justify-center font-semibold transition-all ${
                      currentStep >= step.number
                        ? "bg-gradient-to-r from-cyan-500 to-blue-600 text-white shadow-lg"
                        : "bg-gray-200 dark:bg-gray-700 text-gray-400 dark:text-gray-500"
                    }`}
                  >
                    {currentStep > step.number ? (
                      <FaCheck className="text-xs sm:text-lg" />
                    ) : (
                      <step.icon className="text-[10px] sm:text-base" />
                    )}
                  </div>
                  <span
                    className={`mt-1 sm:mt-2 text-[8px] sm:text-xs lg:text-sm font-medium text-center leading-tight px-0.5 ${
                      currentStep >= step.number
                        ? "text-cyan-600 dark:text-cyan-400 font-semibold"
                        : "text-gray-400 dark:text-gray-500"
                    }`}
                  >
                    {step.title}
                  </span>
                </div>
                {index < steps.length - 1 && (
                  <div
                    className={`flex-1 h-0.5 sm:h-1 mx-0.5 sm:mx-2 lg:mx-4 transition-all ${
                      currentStep > step.number
                        ? "bg-gradient-to-r from-cyan-500 to-blue-600"
                        : "bg-gray-200 dark:bg-gray-700"
                    }`}
                  ></div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Step Content */}
        <div className="step-content">
          {currentStep === 1 && (
            <div className="flex flex-col lg:flex-row gap-6">
              {/* Service info card - shown on desktop right, mobile top */}
              <div className="lg:order-2 lg:w-[340px] flex-shrink-0">
                <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden sticky top-28">
                  {serviceData.image && (
                    <img
                      src={serviceData.image}
                      alt={serviceData.name}
                      className="w-full h-44 sm:h-52 object-cover"
                    />
                  )}
                  <div className="p-4 sm:p-5">
                    <h3 className="text-base sm:text-lg font-bold text-gray-900 leading-snug">
                      {serviceData.name}
                    </h3>
                    {serviceData.packageName && (
                      <span className="inline-block mt-2 px-3 py-1 bg-blue-50 text-blue-700 text-xs font-semibold rounded-full">
                        {serviceData.packageName}
                      </span>
                    )}
                    <div className="mt-3 flex items-center gap-3 text-sm text-gray-500">
                      {serviceData.time && (
                        <span className="flex items-center gap-1">
                          <svg
                            className="w-3.5 h-3.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                          {serviceData.packageDuration || serviceData.time}
                        </span>
                      )}
                      {serviceData.price && serviceData.id !== "bayliner" && (
                        <span className="font-semibold text-gray-900">
                          &euro;{serviceData.price}
                          <span className="text-xs font-normal text-gray-400">
                            /person
                          </span>
                        </span>
                      )}
                      {serviceData.price && serviceData.id === "bayliner" && (
                        <span className="font-semibold text-gray-900">
                          &euro;{serviceData.price}
                          <span className="text-xs font-normal text-gray-400">
                            /group
                          </span>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Calendar */}
              <div className="lg:order-1 flex-1 min-w-0">
                <AvailabilityCalendar
                  serviceId={serviceData.id}
                  onDateSelect={handleDateSelect}
                  onTimeSlotSelect={handleTimeSlotSelect}
                  customSlots={
                    serviceData.id === "speedboat"
                      ? serviceData.selectedPackage === 3
                        ? [
                            // Boat Cruise — 90 min, 5 slots
                            { time: "09:00 - 10:30", capacity: 11, booked: 0 },
                            { time: "12:00 - 13:30", capacity: 11, booked: 0 },
                            { time: "15:00 - 16:30", capacity: 11, booked: 0 },
                            { time: "17:00 - 18:30", capacity: 11, booked: 0 },
                            { time: "19:00 - 20:30", capacity: 11, booked: 0 },
                          ]
                        : serviceData.selectedPackage === 4
                          ? [
                              // Extended Sea Experience — 120 min, 2 slots
                              {
                                time: "09:00 - 11:00",
                                capacity: 11,
                                booked: 0,
                              },
                              {
                                time: "18:00 - 20:00",
                                capacity: 11,
                                booked: 0,
                              },
                            ]
                          : [
                              // Shipwreck & Coastal — 90 min, 2 slots
                              {
                                time: "09:00 - 10:30",
                                capacity: 11,
                                booked: 0,
                              },
                              {
                                time: "17:00 - 18:30",
                                capacity: 11,
                                booked: 0,
                              },
                            ]
                      : serviceData.id === "bayliner"
                        ? serviceData.selectedPackage === 2
                          ? [
                              // Extended Water Sports — 60 min
                              { time: "09:00 - 10:00", capacity: 4, booked: 0 },
                              { time: "11:00 - 12:00", capacity: 4, booked: 0 },
                              { time: "14:00 - 15:00", capacity: 4, booked: 0 },
                              { time: "16:00 - 17:00", capacity: 4, booked: 0 },
                            ]
                          : [
                              // Water Sports Session — 30 min
                              { time: "09:00 - 09:30", capacity: 4, booked: 0 },
                              { time: "10:00 - 10:30", capacity: 4, booked: 0 },
                              { time: "11:00 - 11:30", capacity: 4, booked: 0 },
                              { time: "14:00 - 14:30", capacity: 4, booked: 0 },
                              { time: "15:00 - 15:30", capacity: 4, booked: 0 },
                              { time: "16:00 - 16:30", capacity: 4, booked: 0 },
                              { time: "17:00 - 17:30", capacity: 4, booked: 0 },
                            ]
                        : undefined // yacht, jet-ski use getServiceDefaultSlots
                  }
                />

                <div
                  className="mt-4 sm:mt-8 flex flex-col gap-3 sm:gap-4"
                  ref={continueButtonRef}
                >
                  {bookingData.date && bookingData.timeSlot && (
                    <div className="bg-green-50 dark:bg-green-900/20 border-2 border-green-200 dark:border-green-700 rounded-lg sm:rounded-xl p-3 sm:p-4">
                      <p className="text-green-700 dark:text-green-300 font-semibold flex items-center gap-2 sm:gap-2.5 text-xs sm:text-base">
                        <FaCheck className="text-green-600 dark:text-green-400 flex-shrink-0 text-xs sm:text-base" />
                        <span>
                          {new Date(bookingData.date).toLocaleDateString(
                            "en-US",
                            {
                              weekday: "long",
                              month: "long",
                              day: "numeric",
                              year: "numeric",
                            },
                          )}
                        </span>
                      </p>
                      <p className="text-green-600 dark:text-green-400 text-sm mt-1 ml-6 font-medium">
                        Time: {bookingData.timeSlot}
                      </p>
                    </div>
                  )}
                  <button
                    onClick={handleNextStep}
                    disabled={!bookingData.date || !bookingData.timeSlot}
                    className={`w-full px-4 sm:px-6 py-3 sm:py-4 rounded-lg sm:rounded-xl font-bold transition-all text-sm sm:text-lg ${
                      bookingData.date && bookingData.timeSlot
                        ? "bg-gradient-to-r from-cyan-500 to-blue-600 text-white hover:from-cyan-400 hover:to-blue-500 shadow-lg active:scale-[0.98]"
                        : "bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed"
                    }`}
                  >
                    {bookingData.date && bookingData.timeSlot
                      ? "Continue to Guest Details →"
                      : "Select Date & Time to Continue"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {currentStep === 2 && (
            <div className="max-w-3xl mx-auto">
              {/* Header */}
              <div className="mb-5">
                <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-1">
                  Guest Information
                </h2>
                <p className="text-sm text-slate-500">
                  Provide your contact details to complete the booking
                </p>
              </div>

              <div className="space-y-3">
                {/* Number of Guests */}
                <div className="bg-white border border-slate-200 rounded-xl p-4 sm:p-5">
                  <p className="text-[11px] font-semibold text-slate-400 uppercase tracking-wider mb-3">
                    Number of Guests
                    {bookingData.serviceId === "luxury-yacht" && (
                      <span className="ml-2 normal-case font-normal text-slate-400">
                        max 9
                      </span>
                    )}
                    {bookingData.serviceId === "jet-ski" && (
                      <span className="ml-2 normal-case font-normal text-slate-400">
                        max 2
                      </span>
                    )}
                    {bookingData.serviceId === "speedboat" && (
                      <span className="ml-2 normal-case font-normal text-slate-400">
                        min 1 · max 11
                      </span>
                    )}
                  </p>
                  <div className="flex items-center gap-3">
                    <button
                      onClick={() =>
                        handleGuestsChange(
                          Math.max(
                            getMinGuests(),
                            bookingData.numberOfGuests - 1,
                          ),
                        )
                      }
                      className="w-10 h-10 flex items-center justify-center bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200 transition-colors font-semibold text-lg"
                    >
                      −
                    </button>
                    <div className="min-w-[80px] bg-slate-50 rounded-lg px-5 py-2 text-center border border-slate-200">
                      <span className="text-2xl font-semibold text-slate-900 block">
                        {bookingData.numberOfGuests}
                      </span>
                      <span className="text-[10px] text-slate-400">
                        {bookingData.numberOfGuests === 1 ? "guest" : "guests"}
                      </span>
                    </div>
                    <button
                      onClick={() =>
                        handleGuestsChange(bookingData.numberOfGuests + 1)
                      }
                      disabled={bookingData.numberOfGuests >= getMaxGuests()}
                      className={`w-10 h-10 flex items-center justify-center rounded-lg font-semibold text-lg transition-colors ${
                        bookingData.numberOfGuests >= getMaxGuests()
                          ? "bg-slate-100 text-slate-300 cursor-not-allowed"
                          : "bg-slate-900 text-white hover:bg-slate-700"
                      }`}
                    >
                      +
                    </button>
                  </div>
                </div>

                {/* Jet Ski Package Selector */}
                {bookingData.serviceId === "jet-ski" && (
                  <div className="bg-white border border-slate-200 rounded-xl p-4 sm:p-5">
                    <p className="text-[11px] font-semibold text-slate-400 uppercase tracking-wider mb-3">
                      Select Package
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                      {[
                        {
                          id: "rental-15",
                          label: "15 Min Rental",
                          price: 50,
                          desc: "Quick coastal thrill",
                        },
                        {
                          id: "rental-30",
                          label: "30 Min Rental",
                          price: 90,
                          desc: "More time to explore the coast",
                        },
                      ].map((pkg) => (
                        <button
                          key={pkg.id}
                          onClick={() =>
                            setBookingData((prev) => ({
                              ...prev,
                              jetSkiPackage: pkg.id,
                            }))
                          }
                          className={`p-3 rounded-xl border-2 text-left transition-all ${
                            bookingData.jetSkiPackage === pkg.id
                              ? "border-slate-900 bg-slate-50"
                              : "border-slate-200 hover:border-slate-300"
                          }`}
                        >
                          <p className="font-semibold text-sm text-slate-900">
                            {pkg.label}
                          </p>
                          <p className="text-xs text-slate-500 mt-0.5">
                            {pkg.desc}
                          </p>
                          <p className="text-base font-bold text-slate-900 mt-1">
                            €{pkg.price}
                          </p>
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* Yacht Pricing Info */}
                {bookingData.serviceId === "luxury-yacht" && (
                  <div className="bg-slate-50 border border-slate-200 rounded-xl p-4">
                    <p className="text-[11px] font-semibold text-slate-400 uppercase tracking-wider mb-2">
                      Yacht Charter Pricing
                    </p>
                    <p className="text-sm text-slate-600">
                      €600 base · up to 5 guests &nbsp;·&nbsp; +€50 per extra
                      guest (max 9)
                    </p>
                    <p className="text-sm font-bold text-slate-900 mt-2">
                      Current total: €{getBasePrice()}
                    </p>
                  </div>
                )}

                {/* Contact Details Card */}
                <div className="bg-white border border-slate-200 rounded-xl p-4 sm:p-5">
                  <p className="text-[11px] font-semibold text-slate-400 uppercase tracking-wider mb-4">
                    Contact Details
                  </p>
                  <div className="space-y-4">
                    {/* Full Name */}
                    <div>
                      <label className="block text-xs font-medium text-slate-600 mb-1.5">
                        Full Name <span className="text-red-400">*</span>
                      </label>
                      <input
                        type="text"
                        value={bookingData.customerInfo.name}
                        onChange={(e) =>
                          handleCustomerInfoChange("name", e.target.value)
                        }
                        className={`w-full px-3 py-2.5 text-sm border rounded-lg focus:outline-none focus:border-slate-400 transition-colors bg-white text-slate-900 placeholder-slate-300 ${
                          validationErrors.name
                            ? "border-red-400"
                            : "border-slate-200"
                        }`}
                        placeholder="John Doe"
                        required
                      />
                      {validationErrors.name && (
                        <p className="mt-1 text-xs text-red-500">
                          {validationErrors.name}
                        </p>
                      )}
                    </div>

                    {/* Email */}
                    <div>
                      <label className="block text-xs font-medium text-slate-600 mb-1.5">
                        Email Address <span className="text-red-400">*</span>
                      </label>
                      <input
                        type="email"
                        value={bookingData.customerInfo.email}
                        onChange={(e) =>
                          handleCustomerInfoChange("email", e.target.value)
                        }
                        className={`w-full px-3 py-2.5 text-sm border rounded-lg focus:outline-none focus:border-slate-400 transition-colors bg-white text-slate-900 placeholder-slate-300 ${
                          validationErrors.email
                            ? "border-red-400"
                            : "border-slate-200"
                        }`}
                        placeholder="john.doe@example.com"
                        required
                      />
                      {validationErrors.email && (
                        <p className="mt-1 text-xs text-red-500">
                          {validationErrors.email}
                        </p>
                      )}
                    </div>

                    {/* Phone */}
                    <div>
                      <label className="block text-xs font-medium text-slate-600 mb-1.5">
                        Phone Number <span className="text-red-400">*</span>
                      </label>
                      <div className="flex gap-2">
                        <select
                          value={phonePrefix}
                          onChange={(e) => {
                            setPhonePrefix(e.target.value);
                            handleCustomerInfoChange(
                              "phone",
                              e.target.value + localPhone,
                            );
                          }}
                          className={`w-36 px-2 py-2.5 text-sm border rounded-lg focus:outline-none focus:border-slate-400 transition-colors bg-white text-slate-900 ${
                            validationErrors.phone
                              ? "border-red-400"
                              : "border-slate-200"
                          }`}
                        >
                          {COUNTRY_CODES.map((c) => (
                            <option key={c.code + c.dial} value={c.dial}>
                              {c.dial} {c.name}
                            </option>
                          ))}
                        </select>
                        <input
                          type="tel"
                          value={localPhone}
                          onChange={(e) => {
                            setLocalPhone(e.target.value);
                            handleCustomerInfoChange(
                              "phone",
                              phonePrefix + e.target.value,
                            );
                          }}
                          className={`flex-1 px-3 py-2.5 text-sm border rounded-lg focus:outline-none focus:border-slate-400 transition-colors bg-white text-slate-900 placeholder-slate-300 ${
                            validationErrors.phone
                              ? "border-red-400"
                              : "border-slate-200"
                          }`}
                          placeholder="69 123 4567"
                          required
                        />
                      </div>
                      {validationErrors.phone && (
                        <p className="mt-1 text-xs text-red-500">
                          {validationErrors.phone}
                        </p>
                      )}
                    </div>

                    {/* Address */}
                    <div>
                      <label className="block text-xs font-medium text-slate-600 mb-1.5">
                        Address
                      </label>
                      <input
                        type="text"
                        value={bookingData.customerInfo.address}
                        onChange={(e) =>
                          handleCustomerInfoChange("address", e.target.value)
                        }
                        className="w-full px-3 py-2.5 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-slate-400 transition-colors bg-white text-slate-900 placeholder-slate-300"
                        placeholder="Street, City, Country"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Navigation */}
              <div className="mt-4 flex flex-col-reverse sm:flex-row justify-between gap-3">
                <button
                  onClick={handlePreviousStep}
                  className="w-full sm:w-auto px-5 py-3 text-sm border border-slate-200 rounded-xl font-medium text-slate-600 hover:bg-slate-50 transition-colors"
                >
                  ← Back
                </button>
                <button
                  onClick={() => {
                    if (validateGuestDetails()) {
                      handleNextStep();
                    }
                  }}
                  className="w-full sm:w-auto px-5 py-3 text-sm rounded-xl font-medium transition-colors bg-slate-900 text-white hover:bg-slate-700"
                >
                  Continue to Extras →
                </button>
              </div>
            </div>
          )}

          {currentStep === 3 && (
            <div className="max-w-3xl mx-auto">
              {/* Header */}
              <div className="mb-5">
                <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-1">
                  Add Extras
                </h2>
                <p className="text-sm text-slate-500">
                  Enhance your experience — all optional
                </p>
              </div>

              {/* Drinks */}
              <div className="mb-4 bg-white rounded-xl border border-slate-200 overflow-hidden">
                <div className="px-4 py-3 border-b border-slate-100 bg-slate-50">
                  <p className="text-[11px] font-semibold text-slate-400 uppercase tracking-wider">
                    Drinks
                  </p>
                </div>
                <div className="divide-y divide-slate-100">
                  {extrasOptions.drinks.map((drink) => {
                    const quantity = bookingData.extras.drinks[drink.id] || 0;
                    return (
                      <div
                        key={drink.id}
                        className="flex items-center justify-between px-4 py-3"
                      >
                        <div>
                          <p className="text-sm font-medium text-slate-800">
                            {drink.name}
                          </p>
                          <p className="text-xs text-slate-400">
                            €{drink.price} each
                          </p>
                        </div>
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() =>
                              handleExtrasChange("drinks", drink.id, -1)
                            }
                            disabled={quantity === 0}
                            className={`w-8 h-8 rounded-lg font-semibold text-base transition-colors ${
                              quantity === 0
                                ? "bg-slate-50 text-slate-300 cursor-not-allowed"
                                : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                            }`}
                          >
                            −
                          </button>
                          <span className="w-6 text-center text-sm font-semibold text-slate-900">
                            {quantity}
                          </span>
                          <button
                            onClick={() =>
                              handleExtrasChange("drinks", drink.id, 1)
                            }
                            className="w-8 h-8 rounded-lg bg-slate-900 text-white font-semibold text-base hover:bg-slate-700 transition-colors"
                          >
                            +
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Food */}
              <div className="mb-4 bg-white rounded-xl border border-slate-200 overflow-hidden">
                <div className="px-4 py-3 border-b border-slate-100 bg-slate-50">
                  <p className="text-[11px] font-semibold text-slate-400 uppercase tracking-wider">
                    Food
                  </p>
                  <p className="text-[11px] text-slate-400 mt-0.5">
                    🚤 Another boat will bring the food to you at sea
                  </p>
                </div>
                <div className="divide-y divide-slate-100">
                  {extrasOptions.food.map((item) => {
                    const quantity = bookingData.extras.food[item.id] || 0;
                    return (
                      <div
                        key={item.id}
                        className="flex items-center justify-between px-4 py-3"
                      >
                        <div>
                          <p className="text-sm font-medium text-slate-800">
                            {item.name}
                          </p>
                          <p className="text-xs text-slate-400">
                            €{item.price} each
                          </p>
                        </div>
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() =>
                              handleExtrasChange("food", item.id, -1)
                            }
                            disabled={quantity === 0}
                            className={`w-8 h-8 rounded-lg font-semibold text-base transition-colors ${
                              quantity === 0
                                ? "bg-slate-50 text-slate-300 cursor-not-allowed"
                                : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                            }`}
                          >
                            −
                          </button>
                          <span className="w-6 text-center text-sm font-semibold text-slate-900">
                            {quantity}
                          </span>
                          <button
                            onClick={() =>
                              handleExtrasChange("food", item.id, 1)
                            }
                            className="w-8 h-8 rounded-lg bg-slate-900 text-white font-semibold text-base hover:bg-slate-700 transition-colors"
                          >
                            +
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Order Summary — only when something selected */}
              {(Object.keys(bookingData.extras.drinks).length > 0 ||
                Object.keys(bookingData.extras.food).length > 0 ||
                bookingData.extras.jetSki) && (
                <div className="mb-4 bg-white rounded-xl border border-slate-200 overflow-hidden">
                  <div className="px-4 py-3 border-b border-slate-100 bg-slate-50">
                    <p className="text-[11px] font-semibold text-slate-400 uppercase tracking-wider">
                      Your Selection
                    </p>
                  </div>
                  <div className="divide-y divide-slate-100">
                    {Object.entries(bookingData.extras.drinks).map(
                      ([drinkId, quantity]) => {
                        const drink = extrasOptions.drinks.find(
                          (d) => d.id === drinkId,
                        );
                        return drink ? (
                          <div
                            key={drinkId}
                            className="flex justify-between items-center px-4 py-3"
                          >
                            <span className="text-sm text-slate-700">
                              {drink.name} × {quantity}
                            </span>
                            <span className="text-sm font-semibold text-slate-900">
                              €{(drink.price * quantity).toFixed(2)}
                            </span>
                          </div>
                        ) : null;
                      },
                    )}
                    {Object.entries(bookingData.extras.food).map(
                      ([foodId, quantity]) => {
                        const food = extrasOptions.food.find(
                          (f) => f.id === foodId,
                        );
                        return food ? (
                          <div
                            key={foodId}
                            className="flex justify-between items-center px-4 py-3"
                          >
                            <span className="text-sm text-slate-700">
                              {food.name} × {quantity}
                            </span>
                            <span className="text-sm font-semibold text-slate-900">
                              €{(food.price * quantity).toFixed(2)}
                            </span>
                          </div>
                        ) : null;
                      },
                    )}
                    <div className="flex justify-between items-center px-4 py-3 bg-slate-50">
                      <span className="text-sm font-bold text-slate-900">
                        Extras Total
                      </span>
                      <span className="text-base font-bold text-slate-900">
                        €{(calculateTotalPrice() - getBasePrice()).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              <div className="flex flex-col-reverse sm:flex-row justify-between gap-3 mt-2">
                <button
                  onClick={handlePreviousStep}
                  className="w-full sm:w-auto px-6 py-3 text-sm border border-slate-200 rounded-xl font-medium text-slate-600 hover:bg-slate-50 transition-colors"
                >
                  ← Back
                </button>
                <button
                  onClick={handleNextStep}
                  className="w-full sm:w-auto px-6 py-3 text-sm rounded-xl font-semibold bg-slate-900 text-white hover:bg-slate-700 transition-colors"
                >
                  Continue to Payment →
                </button>
              </div>
            </div>
          )}

          {currentStep === 4 && (
            <div className="max-w-2xl mx-auto">
              <PaymentCheckout
                bookingData={{
                  ...bookingData,
                  extras: {
                    drinks: Object.entries(bookingData.extras.drinks || {})
                      .map(([id, quantity]) => {
                        const drink = extrasOptions.drinks.find(
                          (d) => d.id === id,
                        );
                        return drink ? { ...drink, quantity } : null;
                      })
                      .filter(Boolean),
                    food: Object.entries(bookingData.extras.food || {})
                      .map(([id, quantity]) => {
                        const food = extrasOptions.food.find(
                          (f) => f.id === id,
                        );
                        return food ? { ...food, quantity } : null;
                      })
                      .filter(Boolean),
                    jetSki: bookingData.extras.jetSki,
                  },
                  totalPrice: calculateTotalPrice(),
                }}
                createBooking={createBooking}
                onSuccess={handlePaymentSuccess}
                onError={(error) => console.error("Payment error:", error)}
              />

              <div className="mt-4 sm:mt-6">
                <button
                  onClick={handlePreviousStep}
                  className="w-full sm:w-auto px-4 sm:px-6 py-2.5 sm:py-4 text-sm sm:text-base border-2 border-gray-300 dark:border-gray-600 rounded-lg sm:rounded-xl font-bold text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all active:scale-[0.98]"
                >
                  ← Back to Extras
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Subtle scroll hint — appears when Continue button is below the fold */}
      {currentStep === 1 &&
        bookingData.date &&
        bookingData.timeSlot &&
        !continueBtnVisible && (
          <button
            onClick={() =>
              continueButtonRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              })
            }
            aria-label="Scroll to continue"
            className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50 flex flex-col items-center gap-1 text-slate-400 hover:text-slate-700 transition-colors duration-200"
          >
            <span className="text-[11px] font-medium tracking-widest uppercase opacity-70">
              scroll
            </span>
            <FaChevronDown className="animate-bounce text-base" />
          </button>
        )}
    </>
  );
};

export default BookingFlow;
